import {
  TComponentValue,
} from '@/types/openapi-type';

const details: Record<TComponentValue<'AuditEnvelopStabilizationCombinationType'>, string> = {
  0: 'Append time to ignored stages.',
  1: 'Either time or stages, what ever ends first.',
  2: 'Either time or stages, what ever ends last.',
};

export default {
  details,
};
